export default __webpack_public_path__ + "static/media/image2.eb3dc317.png";